// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ji9vyt2j","separator":"D16YIN70","leftContainer":"hMruL_0K","flexbox":"cYONcwr2","textSectionWrapper":"P4fB7Wfe","section":"HfRxoa8j","loadingSkeletonWrapper":"xdUBrXEZ"};